export default __webpack_public_path__ + "static/media/bs.3efaa836.svg";